import { useState, Fragment } from 'react';
import { TextField } from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

const theme = createTheme({
  overrides: {
  },
});

const useStyles = makeStyles({
  root: {
    height: '36px',
    paddingLeft: 5,
  },
  inputStyle: {
    height: '55px !important',
  },
  datePickerStyle: {
    height: '55px !important',
    margin: '0 5px',
    width: 290,
    flex: '0 0 0px'
  }
});

const style = {
  select: {
    flex: '0 0 0px',
    padding: '0 5px'
  },
};

export default function ValueInput({value, type, onChange}) {
  const [datePickerFocused, setDatePickerFocused] = useState(false);
  const classes = useStyles();

  const onFocusChange = ({ focused }) => {
    setDatePickerFocused(focused)
  };

  const handleOnChange = (e) => {
    onChange(e.target.value);
  };

  const handleOnDateChange = e => {
    onChange(e);
  };

  const getElement = type => {
    switch (type) {
      case 'string':
        return (
          <TextField value={value ? value : ''} style={style.select} sx={{ width: 300 }} onChange={handleOnChange} />
        );
      case 'number':
        return (
          <TextField
            value={value ? value : ''}
            style={style.select}
            onChange={handleOnChange}
            type="number"
            sx={{ width: 300, paddingLeft: '5px', height: '22px' }}
            classes={{ root: classes.inputStyle }}
          />
        );
      case 'date':
      case 'epoch':
        return (
          <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                style={style.select}
                format="MM/dd/yyyy"
                isOutsideRange={() => false}
                {... {InputProps: { classes }}}
                value={new Date(value)}
                onViewChange={(value) => handleOnChange}
                numberOfMonths={1}
                anchorDirection="right"
                onChange={handleOnDateChange}
                focused={datePickerFocused}
                onFocusChange={onFocusChange}
                sx={{ width: 300 }}
                slotProps={{ textField: { variant: 'outlined'}}}
              />
            </LocalizationProvider>
          </ThemeProvider>
        );
      default:
        return (
          <TextField
            disabled
            value={value ? value : ''}
            onChange={handleOnChange}
            sx={{ width: 300 }}
            inputProps={{ style: {paddingLeft: '5px', height: '22px'}, classes: { root: classes.inputStyle }}}
          />
        );
    }
  };

  return (
    <Fragment>
      {getElement(type)}
    </Fragment>
  )
}